module.exports = __webpack_public_path__ + "img/yjd_1.2a2671d2.png";